// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-height {
  top: -50px;
  z-index: 2;
  height: 180px;
}

.card-content {
  margin-top: 0px !important;
  color: var(--ion-color-warning-contrast) !important;
  padding: 11px;
}

.background-img {
  background-color: #fff !important;
}

#profile-image {
  display: block;
  border-radius: 100px;
  border: 3px solid double;
  border: 3px solid #e0e0e0;
  width: 90px;
  height: 90px;
  margin: 50px auto 0;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.7);
}

#profile-info {
  position: relative;
  bottom: 325px;
  width: 100%;
  z-index: 3;
  text-align: center;
}

.header-image {
  height: 25vh;
  width: 100%;
  margin: auto;
  top: 0px;
  position: relative;
}

.image-upload > input {
  display: none;
}

div {
  font-size: 14px;
}

ion-icon {
  font-size: 20px;
}

.icon-arrow {
  position: absolute;
  z-index: 2;
  position: absolute;
}

.card-position {
  height: 323px !important;
}

.contact-details {
  margin-left: 20px;
}

.userInfo {
  display: inline-block;
  vertical-align: middle;
}
.userInfo p {
  margin-left: 11px;
  margin-bottom: 10px;
}

.userInfo1 {
  display: inline-block;
  vertical-align: middle;
}
.userInfo1 p {
  margin-top: -26px !important;
}

.segment-design ion-segment-button {
  font-size: 12px;
  font-weight: 700 !important;
  letter-spacing: normal;
}

[top-65] {
  top: 65% !important;
}

.content-text {
  border: none;
  resize: none;
  text-align: center;
  max-width: 97%;
  margin-top: 62px;
  height: 100px;
  min-height: 120px;
  background: bottom !important;
  color: var(--ion-color-step-550, #737373);
}

.custom-margin {
  padding: 20px 0 0 0;
}

@media (min-height: 884px) {
  .card {
    top: 40px;
  }
}
@media (min-height: 1060px) {
  .card {
    top: 85px;
  }
}
@media (min-height: 1414px) {
  .card {
    top: 29%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/trips/trips-tab/trip-services/about-user/about-user.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,UAAA;EACA,aAAA;AACF;;AAEA;EACE,0BAAA;EACA,mDAAA;EACA,aAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EAEA,WAAA;EACA,UAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAAF;;AAGA;EAEE,wBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,qBAAA;EACA,sBAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;AADJ;;AAKA;EACE,qBAAA;EACA,sBAAA;AAFF;AAIE;EACE,4BAAA;AAFJ;;AAOE;EACE,eAAA;EACA,2BAAA;EACA,sBAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,yCAAA;AAJF;;AAMA;EACE,mBAAA;AAHF;;AAOE;EADF;IAEI,SAAA;EAHF;AACF;AAIE;EAJF;IAKI,SAAA;EADF;AACF;AAEE;EAPF;IAQI,QAAA;EACF;AACF","sourcesContent":[".card-height {\n  top: -50px;\n  z-index: 2;\n  height: 180px;\n}\n\n.card-content {\n  margin-top: 0px !important;\n  color: var(--ion-color-warning-contrast) !important;\n  padding: 11px;\n}\n\n.background-img {\n  background-color: #fff !important;\n}\n\n#profile-image {\n  display: block;\n  border-radius: 100px;\n  border: 3px solid double;\n  border: 3px solid #e0e0e0;\n  width: 90px;\n  height: 90px;\n  margin: 50px auto 0;\n  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.7);\n}\n\n#profile-info {\n  position: relative;\n  bottom: 325px;\n  // top: 70px;\n  width: 100%;\n  z-index: 3;\n  text-align: center;\n}\n\n.header-image {\n  height: 25vh;\n  width: 100%;\n  margin: auto;\n  top: 0px;\n  position: relative;\n}\n\n.image-upload > input {\n  display: none;\n}\n\ndiv {\n  font-size: 14px;\n}\n\nion-icon {\n  font-size: 20px;\n}\n\n.icon-arrow {\n  position: absolute;\n  z-index: 2;\n  position: absolute;\n}\n\n.card-position {\n  // top: -50px !important;\n  height: 323px !important;\n}\n\n.contact-details {\n  margin-left: 20px;\n}\n\n.userInfo {\n  display: inline-block;\n  vertical-align: middle;\n\n  p {\n    margin-left: 11px;\n    margin-bottom: 10px;\n  }\n}\n\n.userInfo1 {\n  display: inline-block;\n  vertical-align: middle;\n\n  p {\n    margin-top: -26px !important;\n  }\n}\n\n.segment-design {\n  ion-segment-button {\n    font-size: 12px;\n    font-weight: 700 !important;\n    letter-spacing: normal;\n  }\n}\n\n[top-65] {\n  top: 65% !important;\n}\n.content-text {\n  border: none;\n  resize: none;\n  text-align: center;\n  max-width: 97%;\n  margin-top: 62px;\n  height: 100px;\n  min-height: 120px;\n  background: bottom !important;\n  color: var(--ion-color-step-550, #737373);\n}\n.custom-margin {\n  padding: 20px 0 0 0;\n}\n// screen height with modalctr card height\n.card{\n  @media (min-height: 884px) {\n    top: 40px;\n  }\n  @media (min-height: 1060px) {\n    top: 85px;\n  }\n  @media (min-height: 1414px) {\n    top: 29%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
